<template>
  <div class="customer-effort-question"
    v-if="
    checkCategory() &&
    question.libraryQuestionId &&
    question.questionType == 'METADATA'
    "
  >
    <!-- <div v-if="'METADATA' === question.questionType&&question.libraryQuestionId" class="customer-effort-question"> -->
    <span
      v-if="
        QUESTIONS_THRESHOLD_MAP[question.questionKey]
      "
      class="customer-effort-option-label"
      >{{
        QUESTIONS_THRESHOLD_MAP[question.questionKey]
          .label
      }}:
    </span>
    <div class="threshold-section">
      <vue-numeric
        class="input-customer-effort-value"
        :placeholder="
          QUESTIONS_THRESHOLD_MAP[question.questionKey]
            .placeholder
        "
        v-bind:minus="false"
        v-bind:precision="0"
        v-model="question.thresholdValue"
        :class="{
          'no-value':
            typeof question.thresholdValue !== 'number',
        }"
        @keypress.native="callHandlePress"
      ></vue-numeric>

      <span class="customer-effort-threshold-title">{{
        QUESTIONS_THRESHOLD_MAP[question.questionKey]
          .title
      }}</span>
      <span class="customer-effort-threshold-des">{{
        QUESTIONS_THRESHOLD_MAP[question.questionKey]
          .desc
      }}</span>
    </div>
  </div>
</template>

<script>
import VueNumeric from "vue-numeric";
import WyUtils from "../../library/wy-utils";

export default {
  name: "WyAutoQAFormThresholdSection",
  components: {VueNumeric},
  props: { 
    question: {
      type: Object,
      required: true,
    },
    category: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      ALLOWED_CATEGORY: ["Customer Effort", "Professionalism"],
      QUESTIONS_THRESHOLD_MAP: {
        individual_hold_time: {
          label: "Individual hold time limit",
          title: "Time (seconds)",
          placeholder: "",
          desc: "Enter the maximum acceptable time for a single hold",
          operator: "",
          optionKey: "",
          libraryOptionText: "",
          value: "",
        },
        conversation_duration: {
          label: "Call duration limit",
          title: "Time (seconds)",
          placeholder: "",
          desc: "Enter the maximum acceptable duration for a call",
          operator: "",
          optionKey: "",
          libraryOptionText: "",
          value: "",
        },
        number_of_hold_events: {
          label: "Maximum holds permitted",
          title: "Hold events (quantity)",
          placeholder: "",
          desc: "Enter the maximum number of holds acceptable during a single call",
          operator: "",
          optionKey: "",
          libraryOptionText: "",
          value: "",
        },
        total_silence_time: {
          label: "Total silence time limit",
          title: "Time (seconds)",
          placeholder: "",
          desc: "Enter the maximum total silence time acceptable during a single call.",
          operator: "",
          optionKey: "",
          libraryOptionText: "",
          value: "",
        },
        avoid_talk_overs: {
          label: "Talk-overs time limit",
          title: "Talk overs (seconds)",
          placeholder: "",
          desc: "Enter the minimum number of seconds talk-over must last to be identified as a talk-over event",
          operator: "",
          optionKey: "",
          libraryOptionText: "",
          value: "",
        }
      },
    };
  },
  methods: {
    callHandlePress(e) {
      this.$emit("handlepress-event", e);
    },
    checkCategory() {
      return WyUtils.isValueInArray(this.category, this.ALLOWED_CATEGORY);
    },
  },
}
</script>

<style>

</style>